import React from 'react';

export const Manifesto = () => (
  <section className="py-24 px-6 sm:px-10 lg:px-16 bg-gradient-to-br from-[#fff5f0] via-[#fef0f0] to-[#fff8f2]">
    <div className="max-w-2xl mx-auto text-center">
      <p className="text-sm uppercase tracking-wider text-[#ff5c35] font-medium mb-6">
        Our manifesto
      </p>
      <h2 className="text-3xl md:text-4xl font-bold mb-8 tracking-tight">
        For those whose minds feel like a handful.
      </h2>
      <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
        <p>
          You collect ideas like some people collect stamps. Your browser has 47 tabs open. Your notes app is a graveyard of half-thoughts.
        </p>
        <p>
          We built Mindfull for overthinkers, overdoers, and anyone who's ever lost a brilliant idea because they couldn't remember where they put it.
        </p>
        <p className="font-medium text-foreground">
          This isn't another productivity tool. It's a second brain that actually works like yours.
        </p>
      </div>
    </div>
  </section>
);
